module.exports = __webpack_public_path__ + "static/media/Sub 8.84c3fe97.JPG";